/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb


// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import $ from 'jquery'
import Rails from '@rails/ujs'
window.$ = $
window.jQuery = $

import 'jquery-ui/ui/widgets/datepicker'
import 'jquery-ui/ui/widgets/tooltip'
import 'bootstrap-datepicker'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css'
import '@popperjs/core'
import 'cocoon-js'
import 'underscore'
import 'backbone'
import 'backbone.marionette'
import 'dropzone'
import '../i18n'
import _ from 'underscore'
import I18nInVue from'../i18n/i18n_in_vue'
import Vue from 'vue/dist/vue.esm.js'
import Vuex from 'vuex'
window._ = _

Rails.start()
Vue.use(Vuex)
Vue.use(I18nInVue)

import 'select2'
import '../../assets/javascripts/kcvs.js.coffee'
import '../../assets/javascripts/helpers.js.coffee'
require('coffee')
import '../../assets/javascripts/initializers.js.coffee'
import '../../assets/javascripts/i18n/translations.js'
import '../../assets/javascripts/controllers/admin_users.js'

window.Vue = Vue // probably not good but I do not have time
window.EventBus = new Vue()